interface IProps {
    image: string,
    title: string,
    text: string
}

export default function MainBenefitsCards(props: IProps) {
    return (
        <div className=" w-[168px] h-[287px] m-5 group md:hover:bg-primary rounded-t-full rounded-b-[3000px] box-border border-[#F5F5F5] border flex items-center flex-col 2xl:m-5 2xl:w-[200px] 2xl:h-[335px]">
            <div className="rounded-full shadow-[0px_96px_135px_rgba(0,0,0,0.1)] md:group-hover:bg-white w-[126.65px] h-[126.65px] m-2 flex justify-center items-center 2xl:w-[148px] 2xl:h-[148px] 2xl:m-4">
                <img src={props.image} alt="Efficiency" className=" w-[72.74px] h-[72.74px] 2xl:w-[85px] 2xl:h-[85px]" />
            </div>
            <h4 className="w-[142.92px] h-[21.17px] md:group-hover:text-white font-Poppins font-bold text-[14px] leading-[120%] text-[#100F10] mb-6 text-center 2xl:text-[16px] 2xl:w-[167.01px]">{props.title}</h4>
            <h5 className="w-[128px] h-[50px] md:group-hover:text-white font-Roboto font-normal text-[10px] leading-[14px] text-center text-[#95A5A5] 2xl:text-[12px] 2xl:w-[149.48px] 2xl:h-[47.42px]">{props.text}</h5>
        </div>
    )
}